import tori from "../images/chatter.gif";
function Icon() {
  const width = 80;
  const height = 80;
  return <img src={tori} width={width} height={height} alt="とりさん" />;
}

export default Icon;
